import { ContentComponentWithDnDLegacyPrev } from './ContentComponentWithDnDLegacyPrev';
import { useHasReorderingGate } from '../../../../reordering/hasReorderingGate';
import { ContentComponent } from '../../../../reordering/adapters/hocs/ContentComponent';
import { jsx as _jsx } from "react/jsx-runtime";
export function ContentComponentWithDnDLegacy(props) {
  const hasReorderingGate = useHasReorderingGate();
  if (hasReorderingGate) {
    return /*#__PURE__*/_jsx(ContentComponent, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsx(ContentComponentWithDnDLegacyPrev, Object.assign({}, props));
}